// extracted by mini-css-extract-plugin
export var gif = "_c4-0";